<template>
  <div class="text" @click.self="work">
    <div>
      <!-- <div class="main2">
        <BInputText
          label-text="专业："
          v-model="searchParam.trainMajorName"
          placeholder="请输入专业名称"
        />
        <BBtnSecondary
          :img-src="require('@/assets/icon_screen.png')"
          :clicked="doSearch"
          hidden-key="true"
          btn-txt="筛选"
        />
      </div> -->
      <div class="search-result">
        <div class="search-functions-headers">
          <div class="box">
            <BBtnPrimary
              :img-src="require('@/assets/new.png')"
              :clicked="majorAdd"
              hidden-key=""
              btn-txt="添加专业"
            />
          </div>
        </div>

        <Table
          :headers="headers"
          :tableData="majorList"
          :length="totalPages"
          :total-visible="7"
          :pageNum1="page"
          v-model="page"
          @input="doSearch(false)"
        >
          <template v-slot:actions="item">
            <div
              style="
                display: flex;
                flex-direction: row;
                justify-content: center;
              "
            >
              <div class="btn-detail" @click="trainMajorEdit(item.data)">
                编辑
              </div>
              <div class="btn-delete" @click="trainMajorDelete(item.data.id)">
                删除
              </div>
            </div>
          </template>
        </Table>
      </div>
    </div>
  </div>
</template>

<script>
import BBtnPrimary from "../../../components2/BBtnPrimary";
import Hub from "../../../events/Hub";
import { majorList, majorDelete } from "@/api/course";
//import BInputText from "../../components2/BInputText";
import Table from "../../../components2/Table2";
//import BBtnSecondary from "../../components2/BBtnSecondary";
import PopupContents from "../../../views2/sample/PopupContents";
import MajorAddDialog from "@/views/business/popComponents/MajorAddDialog";
import Vue from "vue";

export default {
  name: "PopupContents",
  components: {
    Table,
    //BInputText,
    BBtnPrimary,
    //BBtnSecondary,
  },
  props: {
    confirmEvent: Boolean,
  },
  data() {
    return {
      returnData: "this is return data",
      totalPages: 0,
      page: 1,
      limit: 5,
      totalCount: 0,
      headers: [
        { text: "ID", value: "indexNum", align: "center" },
        { text: "专业名称", value: "trainMajorName", sortable: false },
        { text: "创建人", value: "createUserName", sortable: false },
        { text: "创建时间", value: "createTime", sortable: false },
        { text: "操作", value: "actions", align: "center" },
      ],
      searchParam: {
        trainClassName: "",
      },
      data: {},
      majorList: [],
      deleteId: "",
      navi: [{ name: "major-management" }],
    };
  },
  watch: {
    confirmEvent() {
      this.$emit("input", false);
      //this.result(1);
    },
  },
  mounted() {
    this.$nextTick(
      function () {
        Hub.$on("modal-confirm2", this.set);
      }.bind(this)
    );
    this.searchList();
  },
  methods: {
    // 向父页面返回结果
    result(value) {
      this.returnData = value;
      this.$emit("ok", this.returnData);
    },
    work() {
      this.$emit("ok", this.returnData);
    },
    majorAdd() {
      this.data.majorInfo = {};
      Hub.$emit("open-modal2");
      Hub.$emit("set-modal-data2", this.data, "添加专业", MajorAddDialog, true);
    },
    trainMajorEdit(data) {
      var majorInfo = {
        id: data.id,
        trainMajorName: data.trainMajorName,
      };
      this.data.majorInfo = majorInfo;
      Hub.$emit("open-modal2");
      Hub.$emit("set-modal-data2", this.data, "编辑专业", MajorAddDialog, true);
    },
    doSearch(flag) {
      if (flag) {
        this.totalPages = 0;
        this.page = 1;
        this.limit = 5;
        this.totalCounts = 0;
      } else {
        // 查询条件赋值
        if (this.$store.state.major_majorName !== undefined) {
          this.searchParam.trainMajorName = this.$store.state.major_majorName;
        }
      }
      this.searchList();
    },
    async searchList() {
      // 把查询条件存入缓存
      this.$store.commit("SET_MAJOR_MANAGER_PARAMS", this.searchParam);
      var param = {
        trainMajorName: this.searchParam.trainMajorName,
        page: this.page,
        limit: this.limit,
      };
      const data = await majorList(param);
      this.majorList = data.data.majorList;
      this.totalCounts = data.data.totalCounts;
      this.totalPages = Math.ceil(this.totalCounts / this.limit);
    },
    trainMajorDelete(id) {
      this.data.bodyText = "确认是否删除？";
      this.deleteId = id;
      Hub.$emit("open-modal2");
      Hub.$emit(
        "set-modal-data2",
        this.data.bodyText,
        "删除",
        PopupContents,
        true
      );
    },
    async majorDelete(id) {
      var param = {
        id: id,
      };
      const data = await majorDelete(param);
      if (data.code === 0) {
        Vue.prototype.$vsnackbar.show(data.msg);
        this.doSearch(true);
      } else {
        Vue.prototype.$vsnackbar.show(data.msg);
      }
    },

    set(value) {
      console.info(value);
      if (value === 1) {
        // 成功 页面刷新
        this.majorDelete(this.deleteId);
      } else if (value === 2) {
        // 成功 页面刷新
        this.doSearch(true);
      }
    },
  },
  destroyed() {
    Hub.$off("modal-confirm2", this.set);
  },
};
</script>

<style scoped>
.text {
  width: 800px;
  margin-top: 50px;
  height: auto;
}
.box {
  display: flex;
  flex-direction: row;
}
.search-result {
  margin-top: -50px;
}
.btn-detail {
  margin-right: 10px;
  cursor: pointer;
}
.btn-delete {
  cursor: pointer;
}
</style>